import { render, staticRenderFns } from "./SkusMapping.vue?vue&type=template&id=16539e38"
import script from "./SkusMapping.vue?vue&type=script&lang=js"
export * from "./SkusMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports